(() => {
  'use strict';
  if (window.__ptPdpHighImpact20260823) return;
  window.__ptPdpHighImpact20260823 = true;

  const clean = (value = '') => String(value).replace(/\s+/g, ' ').trim();
  const giftRootSelector = '#pt-tea-gift-offer';

  const getGiftCards = (section) => Array.from(section?.querySelectorAll('.gfgBuyXGetYProductCardWrapper') || []);
  const getGiftButton = (card) => card?.querySelector('.gfgBuyXGetYProductBtn');

  const isLocked = (card, button = getGiftButton(card)) => {
    if (!button) return true;
    return button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('gfgBXGY-btn-locked') || card?.classList.contains('gfgBXGY-btn-locked');
  };

  const hasAuthoritativeSelectedState = (card) => {
    const button = getGiftButton(card);
    if (!button) return false;
    const classSignal = `${card.className || ''} ${button.className || ''}`;
    if (/(?:^|\s)(?:is-selected|selected|chosen|btn-remove)(?:\s|$)/i.test(classSignal)) return true;
    const text = clean(button.textContent).toLowerCase();
    if (/auswahl entfernen|remove/.test(text)) return true;
    if (button.dataset.ptManagedSelected !== 'true' && /ausgewählt|selected|chosen/.test(text)) return true;
    return false;
  };

  const isGiftSelected = (card) => {
    const optimistic = card?.dataset.ptGiftOptimistic;
    if (optimistic === 'removed') return false;
    if (optimistic === 'selected') return true;
    return hasAuthoritativeSelectedState(card);
  };

  const normalizeGiftCard = (card) => {
    const button = getGiftButton(card);
    if (!button || isLocked(card, button)) return;
    const selected = isGiftSelected(card);
    if (selected) {
      button.dataset.ptGiftSelected = 'true';
      button.dataset.ptManagedSelected = 'true';
      if (button.dataset.ptGiftPending !== 'true') button.textContent = '✓ Ausgewählt';
    } else {
      delete button.dataset.ptGiftSelected;
      if (button.dataset.ptManagedSelected === 'true') {
        delete button.dataset.ptManagedSelected;
        if (button.dataset.ptGiftPending !== 'true') button.textContent = 'Auswählen';
      }
    }
  };

  const syncGiftIndicator = (section) => {
    if (!section) return;
    const cards = getGiftCards(section);
    cards.forEach(normalizeGiftCard);
    const selected = cards.filter(isGiftSelected).length;
    const status = section.querySelector('[data-pt-gift-status]');
    if (status) {
      status.textContent = `${selected} aktuell gewählt`;
      status.dataset.state = selected > 0 ? 'active' : 'idle';
    }
  };

  const settleGiftCard = (section, card) => {
    if (!card?.isConnected) return;
    const button = getGiftButton(card);
    if (button) delete button.dataset.ptGiftPending;
    delete card.dataset.ptGiftOptimistic;
    syncGiftIndicator(section);
  };

  const handleGiftClick = (section, event) => {
    const button = event.target.closest('.gfgBuyXGetYProductBtn');
    if (!button || !section.contains(button)) return;
    const card = button.closest('.gfgBuyXGetYProductCardWrapper');
    if (!card || isLocked(card, button)) return;
    const selectedBefore = isGiftSelected(card);
    card.dataset.ptGiftOptimistic = selectedBefore ? 'removed' : 'selected';
    button.dataset.ptGiftPending = 'true';
    button.textContent = selectedBefore ? 'Wird entfernt...' : 'Wird ausgewählt...';
    syncGiftIndicator(section);
    window.setTimeout(() => {
      const currentButton = getGiftButton(card);
      if (currentButton) delete currentButton.dataset.ptGiftPending;
      syncGiftIndicator(section);
    }, 180);
    window.setTimeout(() => syncGiftIndicator(section), 650);
    window.setTimeout(() => settleGiftCard(section, card), 1100);
  };

  const initGiftIndicator = () => {
    const section = document.querySelector(giftRootSelector);
    if (!section || section.dataset.ptHighImpactGiftInit === 'true') return;
    section.dataset.ptHighImpactGiftInit = 'true';
    syncGiftIndicator(section);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        syncGiftIndicator(section);
      });
    }).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });
    section.addEventListener('click', (event) => handleGiftClick(section, event));
    document.addEventListener('pt:cart-reconciled', () => syncGiftIndicator(section));
  };

  const smartGiftTabs = new Set();
  let smartGiftTabFrame = 0;

  const getFixedAncestor = (node) => {
    let current = node;
    for (let depth = 0; current && current !== document.body && depth < 8; depth += 1, current = current.parentElement) {
      if (window.getComputedStyle(current).position === 'fixed') return current;
    }
    return null;
  };

  const discoverSmartGiftTabs = () => {
    Array.from(smartGiftTabs).forEach((tab) => {
      if (!tab.isConnected) smartGiftTabs.delete(tab);
    });
    if (smartGiftTabs.size) return;
    const nodes = document.querySelectorAll('button,a,[role="button"],div,span');
    nodes.forEach((node) => {
      if (!/^2\s*[x×]\s*gratis\s*zubehör$/i.test(clean(node.textContent))) return;
      const fixed = getFixedAncestor(node);
      if (fixed) smartGiftTabs.add(fixed);
    });
  };

  const giftQuotaComplete = (section) => {
    const actions = Array.from(section?.querySelectorAll('.pt-gift-card-action') || []);
    if (!actions.length) return false;
    return actions.some((action) => /weiteres bundle hinzufügen/i.test(clean(action.textContent)));
  };

  const getHeaderOffset = () => {
    const header = document.querySelector('header');
    if (!header) return 0;
    const style = window.getComputedStyle(header);
    if (style.position !== 'fixed' && style.position !== 'sticky') return 0;
    return Math.min(120, Math.max(0, header.getBoundingClientRect().height || 0));
  };

  const syncSmartGiftTabs = () => {
    const isBundlePdp = document.body?.classList.contains('pt-mode-bundle');
    if (!isBundlePdp) {
      smartGiftTabs.forEach((tab) => {
        tab.dataset.ptSmartGiftTab = 'true';
        tab.classList.add('pt-smart-gift-tab--hidden');
      });
      return;
    }
    const section = document.querySelector(giftRootSelector);
    if (!section) {
      smartGiftTabs.forEach((tab) => tab.classList.add('pt-smart-gift-tab--hidden'));
      return;
    }
    const passedGiftSection = section.getBoundingClientRect().bottom <= getHeaderOffset();
    const shouldHide = !passedGiftSection || giftQuotaComplete(section);
    smartGiftTabs.forEach((tab) => {
      tab.dataset.ptSmartGiftTab = 'true';
      tab.classList.toggle('pt-smart-gift-tab--hidden', shouldHide);
    });
  };

  const scheduleSmartGiftTabs = () => {
    if (smartGiftTabFrame) return;
    smartGiftTabFrame = requestAnimationFrame(() => {
      smartGiftTabFrame = 0;
      discoverSmartGiftTabs();
      syncSmartGiftTabs();
    });
  };

  const initSmartGiftTabs = () => {
    if (document.documentElement.dataset.ptSmartGiftTabInit !== 'true') {
      document.documentElement.dataset.ptSmartGiftTabInit = 'true';
      window.addEventListener('scroll', scheduleSmartGiftTabs, { passive: true });
      window.addEventListener('resize', scheduleSmartGiftTabs, { passive: true });
      ['cart:change', 'cart:refresh', 'cart:updated', 'cart:update', 'pt:cart-reconciled'].forEach((name) => {
        document.addEventListener(name, () => requestAnimationFrame(scheduleSmartGiftTabs));
      });
      if (document.body) new MutationObserver(scheduleSmartGiftTabs).observe(document.body, { childList: true, subtree: true });
    }
    scheduleSmartGiftTabs();
  };

  const boot = () => {
    initGiftIndicator();
    initSmartGiftTabs();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(boot));
})();
